"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_tile_1 = require("./awsui-tile");
var util_1 = require("../../runtime/util");
var TilesWrapper = /** @class */ (function (_super) {
    __extends(TilesWrapper, _super);
    function TilesWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TilesWrapper.prototype.findItems = function () {
        return this.findAll('.awsui-tiles__tile-container').map(function (r) { return new awsui_tile_1.default(r.getElement()); });
    };
    TilesWrapper.prototype.findItemById = function (id) {
        return new awsui_tile_1.default(this.find(".awsui-tiles__tile-container#" + id + "-label").getElement());
    };
    TilesWrapper.prototype.findInputByValue = function (value) {
        var safeValue = util_1.escapeSelector(value);
        return this.find("input[value=\"" + safeValue + "\"]");
    };
    /**
     * Find an underlying native control by `controlId` property
     * @deprecated use `findInputByValue` instead
     */
    TilesWrapper.prototype.findInputById = function (id) {
        return this.find("input#" + id);
    };
    return TilesWrapper;
}(dom_1.ComponentWrapper));
exports.default = TilesWrapper;
//# sourceMappingURL=awsui-tiles.js.map